import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Form, Button, Row, Col, Input, Select, DatePicker, Divider, Icon, Tooltip, InputNumber } from 'antd';
import { create } from 'kts-scaffold-framework/utils/form';
import moment from 'moment';
import ModulesFormAction from './Modules.Form.Action';

const Option = Select.Option;
const FormItem = Form.Item;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    formData: any;
    index: any;
    onChange?: (value: any) => void;
}

/** 绑定全局数据到props */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState, {}> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentWillReceiveProps() {
        // this.props.getFieldsError()
    }
    render() {
        const { form, index, formData } = this.props; // 获取你的props数据

        const { getFieldDecorator } = form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };

        const lineExtraColSpan = this.modulesState.lineExtraColSpan;
        const messageInfos = this.modulesState.messageInfos;
        const key = this.modulesState.linesKey[index-1];

        return (
            <Form className={css.commonFormTable} layout="vertical">
                <Divider />
                <Row gutter={20}>
                    <Col span={1}>
                        <div className={css.indexIcon}>
                            <Tooltip title="删除该行数据">
                                <Icon
                                    onClick={() => { ModulesAction.deletCommonTable(index - 1); }}
                                    type="minus-circle"
                                    style={{ fontSize: 18, color: 'red' }}
                                />
                            </Tooltip>
                            {/* <span className={css.number}>{index < 10 ? '0' + index : index}</span> */}
                        </div>
                    </Col>
                    <Col span={3}>
                        <FormItem
                            {...formItemLayout}
                            label="序号"
                        >
                            {getFieldDecorator('LineID', {
                                initialValue: formData.LineID,
                                rules: [{
                                    required: false,
                                    //规则注释 pattern: /^.{0,50}$/,
                                    //规则注释 message: '支持不超过50个字符',
                                    ...ModulesAction.getExtraRules('LineID', true)
                                }],
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'LineID',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('LineID_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={4}>
                        <FormItem
                            {...formItemLayout}
                            label="采购商品编号"
                        >
                            {getFieldDecorator('BuyersItemIdentification', {
                                initialValue: formData.BuyersItemIdentification,
                                rules: [{
                                    required: false,
                                    //规则注释 pattern: /^.{0,50}$/,
                                    //规则注释 message: '支持不超过50个字符',
                                    ...ModulesAction.getExtraRules('BuyersItemIdentification', true)
                                }],
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'BuyersItemIdentification',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('BuyersItemIdentification_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={4}>
                        <FormItem
                            {...formItemLayout}
                            label="采购商品名称"
                        >
                            {getFieldDecorator('BuyersItemName', {
                                initialValue: formData.BuyersItemName,
                                rules: [{
                                    required: false,
                                    //规则注释 pattern: /^.{0,100}$/,
                                    //规则注释 message: '支持不超过100个字符',
                                    ...ModulesAction.getExtraRules('BuyersItemName', true)
                                }],
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'BuyersItemName',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('BuyersItemName_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={4}>
                        <FormItem
                            {...formItemLayout}
                            label="采购规格/型号"
                        >
                            {getFieldDecorator('BuyersItemModelName', {
                                initialValue: formData.BuyersItemModelName,
                                rules: [{
                                    required: false,
                                    //规则注释 pattern: /^.{0,100}$/,
                                    //规则注释 message: '支持不超过100个字符',
                                    ...ModulesAction.getExtraRules('BuyersItemModelName', true)
                                }]
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'BuyersItemModelName',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('BuyersItemModelName_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={2}>
                        <FormItem
                            {...formItemLayout}
                            label="单位"
                        >
                            {getFieldDecorator('UnitCode', {
                                initialValue: formData.UnitCode,
                                rules: [{
                                    required: false,
                                    message: '请选择单位',
                                }],
                            })(
                                <Select
                                    placeholder="请选择单位"
                                    onChange={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'UnitCode',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e,
                                    })}
                                >
                                    <Option value="TNE">吨</Option>
                                    <Option value="KGM">千克</Option>
                                    <Option value="MTR">米</Option>
                                    <Option value="ST">片</Option>
                                    <Option value="ZZ1">支</Option>
                                    <Option value="EA">个</Option>
                                    <Option value="SET">套</Option>
                                    <Option value="BX">盒</Option>
                                    <Option value="ZZ0">台</Option>
                                    <Option value="CS">箱</Option>
                                    <Option value="PK">包</Option>
                                    <Option value="BO">瓶</Option>
                                    <Option value="H87">件</Option>
                                </Select>
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('UnitCode_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={3}>
                        <FormItem
                            {...formItemLayout}
                            label="收货数量"
                        >
                            {getFieldDecorator('ReceivedQuantity', {
                                initialValue: formData.ReceivedQuantity,
                                rules: [{
                                    required: false,
                                    validator: ModulesFormAction.validateField,
                                    //规则注释 validator: this.OrderedQuantity,
                                    ...ModulesAction.getExtraRules('ReceivedQuantity', true)
                                }],
                            })(
                                <InputNumber
                                    // type="number"
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'ReceivedQuantity',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('ReceivedQuantity_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={3}>
                        <FormItem
                            {...formItemLayout}
                            label="入库数量"
                        >
                            {getFieldDecorator('StockInQuantity', {
                                initialValue: formData.StockInQuantity,
                                rules: [{
                                    required: true,
                                    validator: ModulesFormAction.validateField,
                                    //规则注释 validator: this.checkQuantity,
                                    // pattern: /^[0-9](?:\d{0,14}\.\d{0,2}|\d{0,14})$/,
                                    //规则注释 message: '支持不超过15位正数',
                                    message: '必填',
                                    ...ModulesAction.getExtraRules('StockInQuantity', true)
                                }],
                            })(
                                <InputNumber
                                    // type="number"
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'StockInQuantity',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('StockInQuantity_' + key))}
                        </FormItem>
                    </Col>

                </Row>
                <Row>
                    <Col span={23} offset={1} >
                        <Row gutter={20}>
                            <Col span={lineExtraColSpan}>
                                <FormItem
                                    {...formItemLayout}
                                    label="销售商品编号"
                                >
                                    {getFieldDecorator('SellersItemIdentification', {
                                        initialValue: formData.SellersItemIdentification,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,50}$/,
                                            //规则注释 message: '支持不超过50个字符',
                                            ...ModulesAction.getExtraRules('SellersItemIdentification', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'SellersItemIdentification',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('SellersItemIdentification_' + key))}
                                </FormItem>
                            </Col>
                            <Col span={lineExtraColSpan}>
                                <FormItem
                                    {...formItemLayout}
                                    label="销售商品名称"
                                >
                                    {getFieldDecorator('SellersItemName', {
                                        initialValue: formData.SellersItemName,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,100}$/,
                                            //规则注释 message: '支持不超过100个字符',
                                            ...ModulesAction.getExtraRules('SellersItemName', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'SellersItemName',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('SellersItemName_' + key))}
                                </FormItem>
                            </Col>
                            <Col span={lineExtraColSpan}>
                                <FormItem
                                    {...formItemLayout}
                                    label="销售规格/型号"
                                >
                                    {getFieldDecorator('SellersItemModelName', {
                                        initialValue: formData.SellersItemModelName,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,100}$/,
                                            //规则注释 message: '支持不超过100个字符',
                                            ...ModulesAction.getExtraRules('SellersItemModelName', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'SellersItemModelName',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('SellersItemModelName_' + key))}
                                </FormItem>
                            </Col>
                            <Col span={lineExtraColSpan}>
                                <FormItem
                                    {...formItemLayout}
                                    label="来源单据"
                                >
                                    {getFieldDecorator('DocumentReference', {
                                        initialValue: formData.DocumentReference,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,50}$/,
                                            //规则注释 message: '支持不超过50个字符',
                                            ...ModulesAction.getExtraRules('DocumentReference', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'DocumentReference',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('DocumentReference_' + key))}
                                </FormItem>
                            </Col>
                            <Col span={lineExtraColSpan}>
                                <FormItem
                                    {...formItemLayout}
                                    label="来源单据行"
                                >
                                    {getFieldDecorator('LineReference', {
                                        initialValue: formData.LineReference,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,50}$/,
                                            //规则注释 message: '支持不超过50个字符',
                                            ...ModulesAction.getExtraRules('LineReference', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'LineReference',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('LineReference_' + key))}
                                </FormItem>
                            </Col>
                            <Col span={lineExtraColSpan}>
                                <FormItem
                                    {...formItemLayout}
                                    label="入库描述"
                                >
                                    {getFieldDecorator('Description', {
                                        initialValue: formData.Description,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,100}$/,
                                            //规则注释 message: '支持不超过100个字符',
                                            ...ModulesAction.getExtraRules('Description', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'Description',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('Description_' + key))}
                                </FormItem>
                            </Col>
                            {ModulesAction.getExtraTemplate(this.modulesState.stockInNoticeForm, form, formItemLayout, true, lineExtraColSpan, index - 1)}
                        </Row>
                    </Col>
                </Row>
            </Form>
        );
    }
    /**
     * 发货数量     规则注释 
     */
    // private OrderedQuantity(rule: any, value: any, callback: any) {
    //     let arr = value ? value.toString().split(".") : [''];
    //     if (value < 0) {
    //         return callback('支持不超过15位正数');
    //     } else if (arr.length > 1 && arr[0].length + arr[1].length > 15) {
    //         return callback('支持不超过15位正数');
    //     } else if (arr.length <= 1 && arr[0].length > 15) {
    //         return callback('支持不超过15位正数');
    //     } else {
    //         return callback();
    //     }
    // }
    /**
     * 校验数量     规则注释 
     */
    // private checkQuantity(rule: any, value: any, callback: any) {
    //     let arr = value ? value.toString().split(".") : [''];
    //     if (value === '' || isNaN(value) || value < 0 || value === null || value === undefined) {
    //         return callback('支持不超过15位正数');
    //     } else if (arr.length > 1 && arr[0].length + arr[1].length > 15) {
    //         return callback('支持不超过15位正数');
    //     } else if (arr.length <= 1 && arr[0].length > 15) {
    //         return callback('支持不超过15位正数');
    //     } else {
    //         return callback();
    //     }
    // }

}


// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/UI.StockInNoticeFormTable.tsx